import React, { useRef } from "react";
import { compose } from "redux";

import draggable from "fantastic/components/hoc/draggable";
import droppable from "fantastic/components/hoc/droppable";
import selectable from "fantastic/components/hoc/selectable";

import BaseItem from "./BaseItem";

export default compose(
  selectable(),
  droppable("ITEM"),
  draggable("ITEM")
)(BaseItem);
